import { useContext, useState, useEffect, useRef } from 'react';
import { useSelector } from 'react-redux';
import PageContext from "./PageContext";
import { HttpContext } from '../../api-services/HttpService';
import ApiRequestButton from './ApiRequestButton';
import DynamicPageInput from './DynamicPageInputCopy.jsx';
import dynamicValidation from '../functions/dynamicValidation';
import dynamicTransformation from '../functions/dynamicTransformation';
import validateInputArray from '../functions/validateInputArray';
import CCOffcanvas from './CCOffcanvas.tsx';
import ButtonComponent from './ButtonComponent.jsx';
 
import getFeeCategoryOptions from '../functions/getFeeCategoryOptions';
import { features } from '../../config/clientResolver';
import isNullOrUndefined from '../functions/isNullOrUndefined.js'; 

const AddRebateSetupModal = () => {
    // get context from parent
    const { 
        addRebateSetupModal, 
        setAddRebateSetupModal, 
        masterCompanyData,
        getRefreshData,  
        snackbarAlert, 
        rebateInputTypeId, 
        rebateSetupConfig, 
        rebateSetupLists, 
        setRebateSetupLists, 
        fullFeeCategoryList,
        feeCategoryList
    } = useContext(PageContext);
    // initialize http context 
    const {
        POST, 
    } = useContext(HttpContext);
    // get persistant redux global state from store
    const company = useSelector((state) => state.company);
    // initialize state
    const [values, setValues] = useState({}); 
    const [config, setConfig] = useState([]); 
    const [error, setError] = useState([{}]);
    const [masterSetupBool, setMasterSetupBool] = useState(false); 
    // initialize useRef
    const initialRender = useRef(true); 

    // event handler for DynamicPageInput change 
    const onInputChange = () => {
        let temp = values; 
        // set state for filter
        setMasterSetupBool(masterSetupBool => masterSetupBool = temp['mastersetupbool']); 
        // if adding master setup bool make rate and master setup id null
        if (temp['mastersetupbool'] === true){
            temp['incentiverate'] = null; 
            temp['masterincentivesetupid'] = null; 
        } 
        // set inputs to null if they are empty strings
        if (temp['masterincentivesetupid'] != null && temp['masterincentivesetupid'].length == 0){
            temp['masterincentivesetupid'] = null; 
        }  
        if (temp['incentiverate'] != null && temp['incentiverate'].length == 0){
            temp['incentiverate'] = null;
        }
        // set values 
        setValues(values => values = temp); 
    }

    // event handler for submit click 
    const onSubmitClick = () =>{
        return new Promise((resolve, reject) => {
            let requestValues = [{...values}]; 
            // validate input
            let checkError = validateInputArray(
                requestValues, 
                rebateSetupConfig,
                dynamicValidation,
                {
                    ...rebateSetupLists, 
                    companyid: {
                        override: false, 
                        list: rebateSetupLists['companyid'] 
                    } 
                }, 
                snackbarAlert,  
                error, 
                setError, 
                dynamicTransformation, 
                {
                    incentiverate: {
                        rateTypeId: rebateInputTypeId,
                    } 
                }
            ); 
            // exit request if error 
            if (checkError) {
                reject(); 
                return; 
            }
            // add mastercompanyid to request body 
            requestValues[0]['mastercompanyid'] = masterCompanyData['mastercompanyid']; 

            // use POST function to make post request 
            let response; 
            POST('/client/incentiveSetups', {
                ...requestValues[0]
            }).then(res => {
                console.log(res);
                response = res; 
                // hide modal 
                setAddRebateSetupModal(addRebateSetupModal => addRebateSetupModal = false);
                // default tiers and rate
                values['minspend'] = null;
                values['maxspend'] = null;
                values['incentiverate'] = null;
                // trigger success alert
                snackbarAlert(true, 'Successfully uploaded data.', 'success');
                // refresh CompanyDetailsPage using function from parent
                return getRefreshData();
            }).then(res => {
                console.log(res);
                // resolve on success
                resolve(response); 
            }).catch(err => {
                console.log(err);
                // show alert on error
                snackbarAlert(true, 'Error uploading data.', 'error');
                // reject on error
                reject(err); 
            }); 
        }); 
    }

    // useEffect to run on config change 
    useEffect(() => {
        if (rebateSetupConfig){
            setConfig(config => config = rebateSetupConfig); 
            // set default values 
            let temp = {}; 
            for (let i = 0; i < rebateSetupConfig.length; i++ ) {
                if (rebateSetupConfig[i]['columnid'] == 'active') {
                    temp['active'] = rebateSetupLists['active'][0]; 
                }   
            }
            setValues(values => values = temp); 
        }
    }, [rebateSetupConfig]);

    // useEffect to run on data change 
    useEffect(() => {
        onInputChange(); 
    }, [values]); 

    // filter feeCategory options on companyid change
    useEffect(() => {
        // do not run on initial render
        if (!initialRender.current && !isNullOrUndefined(values.companyid)){
            // set status var from dropdown 
            // declare list of functions with parameters to filter/search list
            let filteredList = getFeeCategoryOptions(features.feeCategorySpendMapping, values.companyid, fullFeeCategoryList, feeCategoryList);
            // update option list
            setRebateSetupLists(prev => ({
                ...prev, 
                feecategoryid: filteredList
            })); 
            // clear feecategory value
            const { feecategoryid, ...rest } = values; 
            setValues(rest);          
        }
        else{
            initialRender.current = false;
            // update option list
            setRebateSetupLists(prev => ({
                ...prev, 
                feecategoryid: []
            })); 
        }
    }, [values.companyid]); 

    return(
        <> 
            <CCOffcanvas
                title='Add Rebate Setup'
                show={addRebateSetupModal}
                onCanvasClose={()=>setAddRebateSetupModal(addRebateSetupModal => addRebateSetupModal = false)}
                bodyCssClassName="offcanvas-body bg-white p-3 pt-2"
                offCanvasClassName="offcanvas-parent-card-30"
                >
                    <div className="d-flex flex-column h-100">
                        <div className="d-flex flex-column gap-3 flex-grow-1 overflow-scroll">
                            {/* inputs and dropdowns for sub company info */}
                            {config.map((el) => 
                                el['add'] == true &&
                                ((el['columnid'] != 'incentiverate' && el['columnid'] != 'masterincentivesetupid') || !masterSetupBool) ?
                                <>
                                    <div>
                                        <DynamicPageInput 
                                            data={values} 
                                            setData={setValues} 
                                            config={el} 
                                            args={rebateSetupLists} 
                                            width={'100%'} 
                                            showError={error[0][el['columnid']]}
                                            topAlignTypography={true}
                                        />
                                    </div>
                                </>
                                :<></>
                            )}
                        </div>
                        {/* submit button to add rebate setup */}
                        <div
                            className="d-flex justify-content-end p-3 w-100 offcanvas-footer z-2" style={{height: '65px'}}
                        >
                            <ButtonComponent tag={"Cancel"} 
                                border={'#fcd800 1px solid'} background={'#fff'} color={'#001317'} 
                                onButtonClick={()=>setAddRebateSetupModal(addRebateSetupModal => addRebateSetupModal = false)}
                            />  
                            <ApiRequestButton onButtonClick={onSubmitClick} />  
                        </div>
                    </div>
            </CCOffcanvas>
        </>
    );
}

export default AddRebateSetupModal; 